import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { FIELD_TYPES } from 'utility/constants';
import LongText from '__components/Inputs/LongText';
import { MAX_DESCRIPTION_LENGTH } from './userDescriptionContext';
import { UserDescriptionWrapper } from './styles';

type DescriptionProps = {
  setUserDescription: (userDescription: string) => void;
  userDescription: string;
  isActive?: boolean;
  addTopSpacer?: string;
};

export const UserDescription = ({
  setUserDescription,
  userDescription,
  isActive = true,
  addTopSpacer = '0px',
}: DescriptionProps) => {
  const { t } = useTranslation();
  const ref = useRef(null);

  // the div is to prevent the label getting "crushed"
  return (
    <UserDescriptionWrapper addTopSpacer={addTopSpacer}>
      <LongText
        ref={ref}
        value={userDescription}
        onChange={setUserDescription}
        label={t('Additional Description')}
        fieldType={FIELD_TYPES.LongText.type}
        placeholder={t('Enter Additional Description')}
        maxLength={MAX_DESCRIPTION_LENGTH}
        disabled={!isActive}
        enableResize={false}
        data-qa="additional-description"
      />
    </UserDescriptionWrapper>
  );
};
